// extracted by mini-css-extract-plugin
export var article = "style-module--article--5585b";
export var content = "style-module--content--23de9";
export var footer = "style-module--footer--a2b25";
export var header = "style-module--header--d2148";
export var heading = "style-module--heading--64da9";
export var image = "style-module--image--2b2ee";
export var list = "style-module--list--9ff32";
export var noOverlap = "style-module--noOverlap--a28f8";
export var overlapBoth = "style-module--overlapBoth--7402d";
export var overlapLeft = "style-module--overlapLeft--bc285";
export var overlapLeftExceptTablet = "style-module--overlapLeftExceptTablet--20efc";
export var overlapNone = "style-module--overlapNone--56567";
export var paragraph = "style-module--paragraph--5b8f2";
export var pdfThumbnail = "style-module--pdfThumbnail--148cd";
export var quote = "style-module--quote--dcd89";
export var summary = "style-module--summary--bdb2d";